module.exports = __webpack_public_path__ + "img/zhxy_image_13.4ef25b4d.png";